<app-menu-common url="logistic"></app-menu-common>
<div class="flexrow header_planning">
  <!-- <div class="date_selecteur" >
  <button mat-icon-button aria-label="jour précédent" (click)="variationDate(-1)">
    <mat-icon>arrow_back_ios</mat-icon>
  </button>
  <mat-form-field>
    <!-- <mat-label>Date de livraison</mat-label>
    matInput
    [matDatepicker]="picker"
    [value]="date"
    (dateChange)="dateChange($event)"
    />
  <mat-hint>JJ/MM/AAAA</mat-hint>
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
<button mat-icon-button aria-label="jour suivant"  (click)="variationDate(1)">
  <mat-icon>arrow_forward_ios</mat-icon>
</button>
</div> -->

<app-select-date label="" [date]="date" (dateChange)="dateChange(date)" ></app-select-date>

<mat-form-field>
  <mat-label>recherche dans liv du jour</mat-label>
  <input matInput (keyup)="applyFilter($event)" >
</mat-form-field>
<mat-divider [vertical]="true" ></mat-divider>
<mat-form-field>
  <mat-label>recherche Livs d'un client</mat-label>
  <input matInput (keyup)="applyFilter($event)" >
</mat-form-field>


</div>
@if (dataSource) {
  @if (dataSource) {
    <div class="pagecontent"  >
      <!-- <table mat-table matSort      [dataSource]="dataSource" class="mat-elevation-z2"  matSortDisableClear  > -->
      <table mat-table matSort (matSortChange)="announceSortChange($event)"     [dataSource]="dataSource" class="mat-elevation-z2"  matSortDisableClear  >
        <ng-container matColumnDef="id" >
          <th mat-header-cell *matHeaderCellDef  mat-sort-header sortActionDescription="Tri par numéro de commande" >Id</th>
          <!-- <td mat-cell *matCellDef="let order;" > {{order.id}}</td> -->
          <td mat-cell *matCellDef="let order;" >{{order.id}}</td>
        </ng-container>
        <ng-container matColumnDef="client">
          <th mat-header-cell *matHeaderCellDef  mat-sort-header sortActionDescription="Tri par Client" >Client</th>
          <td mat-cell *matCellDef="let order;" > {{ order.client }}</td>
          <!-- <td mat-cell *matCellDef="let order;" > {{order.lnk_customer ? ( (order.lnk_customer.firstname??'') + ' ' + (order.lnk_customer.name??'') )  : ''}}</td> -->
        </ng-container>
        <ng-container matColumnDef="city">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Tri par Ville"  >Ville</th>
          <td mat-cell *matCellDef="let order;" > {{ order.city }}</td>
        </ng-container>
        <!-- <ng-container matColumnDef="slot">
        <th mat-header-cell *matHeaderCellDef >Crénaux</th>
        <td mat-cell *matCellDef="let order;" > {{ getOpAndSlot( deliveryOpAndSlot$ | async , order.lnk_delivery )   }}</td>
      </ng-container> -->
      <ng-container matColumnDef="slot">
        <th mat-header-cell *matHeaderCellDef  mat-sort-header sortActionDescription="Tri par Crénaux"  >Crénaux</th>
        <td mat-cell *matCellDef="let order;" > {{ order.slot   }}</td>
      </ng-container>
      <ng-container matColumnDef="products">
        <th mat-header-cell *matHeaderCellDef >Produits</th>
        <td mat-cell *matCellDef="let order;  let iOrders = index" >
          <div >
            @for(product of order.products; track $index ) {
              <div class="flexrow"  >
                <!-- <div  >{{ product }}</div> -->
                <!-- <div>order line {{orders[iOrders].lines | json}}  </div> -->
                <!-- <div>index {{$index}}</div> -->
                <!-- <div>order line index {{orders[iOrders ].lines[$index] | json}}</div> -->
                <a href="#" [routerLink]="['/sales/variant', deliveries[iOrders].lnk_order.lines![$index]['id'],  deliveries[iOrders].lnk_order.lines![$index]['template']]" target="_blank">{{ product }}</a>
              </div>
              @if($index< (order.products.length -1 ) ){  <mat-divider></mat-divider>   }
            }
          </div>
        </td>
      </ng-container>
      <!-- <ng-container matColumnDef="p_name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header >Produit</th>
      <td mat-cell *matCellDef="let order;" > {{order.get("lnk_product").get("name").value}} </td>
    </ng-container> -->
    <tr mat-header-row class="table_head" *matHeaderRowDef="displayedColumns sticky: true "   ></tr>
    <!-- <tr mat-row *matRowDef="let row; columns: displayedColumns;"  ></tr> -->
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onClickRow(row, $event)" (mouseover)="onMouseOver(row)" (mouseout)="onMouseOut(row)" class="row"></tr>
  </table>
</div>
}
}







<!--
<ng-container *ngIf="dataSource">
  <div class="pagecontent" *ngIf="dataSource" formArrayName="prices">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z2"  matSortDisableClear matSort >
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
        <td mat-cell *matCellDef="let order;" > {{order.id}}</td>
      </ng-container>
      <ng-kcontainer matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Client</th>
        <td mat-cell *matCellDef="let order;" > {{order.lnk_customer ? ( (order.lnk_customer.firstname??'') + ' ' + (order.lnk_customer.name??'') )  : ''}}</td>
      </ng-container>
      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Ville</th>
        <td mat-cell *matCellDef="let order;" > {{ deliveryCity(order) }}</td>
      </ng-container>
      <ng-container matColumnDef="sort">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Crénaux</th>
        <td mat-cell *matCellDef="let order;" > {{ getOpAndSlot( deliveryOpAndSlot$ | async , order.lnk_delivery )   }}</td>
      </ng-container>
      <ng-container matColumnDef="products">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Produits</th>
        <td mat-cell *matCellDef="let order;" >
          <div >
            @for(line of order.lines; track line.id) {
              <div class="flexrow" >
                <div>{{line.qty}}&nbsp;</div>
                <div>{{ line.product_name  }}</div>
              </div>
              <!-- {{line.qty}}&nbsp;x&nbsp;{{ line.product_name  }}
            }
          </div>
        </td>
      </ng-container>

      <!-- <ng-container matColumnDef="p_name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header >Produit</th>
      <td mat-cell *matCellDef="let order;" > {{order.get("lnk_product").get("name").value}} </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true"  ></tr>
    <tr  mat-row *matRowDef="let row; columns: displayedColumns;"  ></tr>

  </table>
</div>
</ng-container> -->
